import Vue from 'vue'
import { API_URL } from '@/config'
import router from '@/router'

export const person = {

  namespaced: true,

  state: {
    person: {},
    comments: false,
    changelog: false,
  },

  getters: {
    person: state => state.person,
    comments: state => state.comments,
    changelog: state => state.changelog,
  },

  mutations: {
    setPerson(state, person) { state.person = person },
    setPhoto: (state, picture) => {
      state.person.picture = {
        name: picture.name,
        type: picture.type,
        size: picture.size,
        blob: picture.blob,
      };
    },
    setComments(state, comments) { state.comments = comments },
    setChangelog(state, changelog) { state.changelog = changelog },
    setPublish(state, publish) { state.person.publish = publish },
  },

  actions: {

    // getOptions: () => Vue.axios.get(API_URL + '/entities', { params: {
    //   models: ['App\\Models\\Person'],
    //   filter_display: true,
    // }}),

    async getPerson({ commit }) {
      const person = await Vue.axios.get(API_URL + '/persons/' + router.currentRoute.params.id);
      commit('setComments', false);
      commit('setChangelog', false);
      commit('setPerson', person.data);
    },

    toggleComments({ state, commit }) {
      commit('setChangelog', false);
      commit('setComments', !state.comments);
    },

    toggleChangelog({ state, commit }) {
      commit('setComments', false);
      commit('setChangelog', !state.changelog);
    },

  }
}
